export const GET_ALL_AUTH_DATA = "GET_ALL_AUTH_DATA"

export const GET_CURRENT_UPVOTES = "GET_CURRENT_UPVOTES"

export const GET_CURRENT_COLLECTIONS = "GET_CURRENT_COLLECTIONS"

export const POST_COMMENT = "POST_COMMENT"
